<!-- filters modal -->
@if (showFilters) {
  <!-- filtes view -->
  <div class="mt-filter-wrapper-blur">
    <mat-card class="mt-filter-card right animated slideInRight fast">
      <mat-card-content class="mt-filter-content mt-10">
        <div class="py-10" fxLayout="row wrap">
          <div [fxFlex]="90">
            <mt-h3>Filters</mt-h3>
            <p class="sub-text">Choose the filters which you want</p>
          </div>
          <span class="sp"></span>
          <mt-btn class="icon error" (onAction)="openFilters($event)">
            <mat-icon>clear</mat-icon>
          </mt-btn>
        </div>
        @if (chipsList && chipsList.length > 0) {
          <div [ngClass]="isAllFilter ? '' : 'mt-minmize-filter-view'">
            <div class="p-10 pl-20">
              <div class="mt-filter-container">
                <span>Filtered&nbsp;By:&nbsp;</span>
                <mat-chip-grid #chipList class="mt-chip-wrapper">
                  @for (filter of chipsList; track filter; let i = $index) {
                    <mat-chip
                      selectable="true"
                      [removable]="!filter.nonRemovable"
                      (removed)="removeAccountsFilter(filter)"
                      >
                      @if (filter.type == 'select') {
                        @if (filter.display) {
                          {{ filter.name }} :&nbsp;{{ filter.display }}
                        }
                        @if (!filter.display) {
                          {{ filter.name }} :&nbsp;{{ filter.value }}
                        }
                      }
                      @if (filter.type == 'date') {
                        {{ filter.name }} :&nbsp;{{ filter.value | date: 'dd MMM yyyy' }}
                      }
                      @if (!filter.nonRemovable) {
                        <mat-icon matChipRemove>cancel</mat-icon>
                      }
                    </mat-chip>
                  }
                </mat-chip-grid>
              </div>
            </div>
          </div>
          @if (chipsList.length > 6) {
            <div fxLayout="row">
              <mt-btn class="nobg primary" (onAction)="showAppliedFilters()">
                {{ isAllFilter ? 'Show less' : 'Show more' }}
                <mat-icon>{{ isAllFilter ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
              </mt-btn>
            </div>
          }
        }
        <!-- ./filtes view -->
        <!-- filters -->
        @if (filtersArray && filtersArray.length > 0) {
          <div fxLayout="row wrap">
            @for (filter of filtersArray; track filter; let i = $index) {
              @if (filter[pageName]) {
                @if (filter.type == 'select' &&  ((filter.options && filter.options.length > 0) || (filter.totalOptions && filter.totalOptions.length > 0))) {
                  <div class="my-7" [fxFlex]="100">
                    <mat-form-field appearance="outline" class="moneytor-input">
                      @if (filter.name) {
                        <mat-label>{{ filter.name }}</mat-label>
                      }
                      <mat-select
                        [placeholder]="filter.name"
                        [(ngModel)]="filterParams[filter.model]"
                        [name]="filter.name"
                        (selectionChange)="onChangeFilter(filter.onChangeParam1, filter.model, $event)"
                        [multiple]="filter.multiple"
                        #filterSelect="ngModel"
                        >
                        @if (filter.multiple) {
                          <mt-select-all [model]="filterSelect" [values]="filter" (onSelectAll)="onSelectAll($event)">
                          </mt-select-all>
                        }
                        @if (filter.value) {
                          @for (option of filter.options; track option) {
                            <mat-option [value]="option[filter.value]">
                              {{ option[filter.display] }}
                            </mat-option>
                          }
                        }
                        @if (!filter.value) {
                          @for (option of filter.options; track option) {
                            <mat-option [value]="option">
                              {{ option }}
                            </mat-option>
                          }
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }
                @if (filter.type == 'date') {
                  <div class="my-7" [fxFlex]="100">
                    <mat-form-field appearance="outline" class="moneytor-input">
                      @if (filter.name) {
                        <mat-label>{{ filter.name }}</mat-label>
                      }
                      <input
                        matInput
                        [matDatepicker]="i"
                        (click)="i.open()"
                        [(ngModel)]="filterParams[filter.model]"
                        [min]="filterParams[filter.min]"
                        [max]="filterParams[filter.max]"
                        [placeholder]="filter.name"
                        [name]="filter.name"
                        />
                      <mat-datepicker-toggle matSuffix [for]="i"></mat-datepicker-toggle>
                      <mat-datepicker #i></mat-datepicker>
                    </mat-form-field>
                  </div>
                }
              }
            }
          </div>
        }
      </mat-card-content>
      <mat-card-actions class="mt-filter-wrapper pr-10">
        <mt-btn class="nobg error" (onAction)="onApplyFilter(false)">
          Clear filters
        </mt-btn>
        <mt-btn (onAction)="onApplyFilter(true)">
          Apply filters
        </mt-btn>
      </mat-card-actions>
    </mat-card>
  </div>
}
